export const userSlice = (set) => ({
  // User State
  isVerified: false,
  user: null,
  userData: null,

  // User Actions
  login: (userObj) => {
    set({ user: userObj });
    localStorage.setItem(
      process.env.REACT_APP_LOCAL_STORAGE_USER_KEY,
      JSON.stringify(userObj)
    );
  },

  logout: () => {
    set({
      isVerified: 0,
      user: null,
      userData: null,
    });
    localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_USER_KEY);
    localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_CART);
    localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_HISTORIC);
    localStorage.removeItem(process.env.REACT_APP_LOCAL_STORAGE_HISTORIC_CITY);
  },

  setVerification: (num) => {
    set({
      isVerified: num,
    });
  },

  setUserData: (data) => {
    set({
      userData: data,
    });
  },
});
